'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../components');

var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _upgradeRegularUserPackage = require('../../redux/modules/upgradeRegularUserPackage');



var _RegularPackages = require('./components/RegularPackages');var _RegularPackages2 = _interopRequireDefault(_RegularPackages);
var _index = require('../index');
var _packagesData = require('../../packagesData');






var _messageModal = require('../../redux/modules/messageModal');
var _paymentCalculation = require('../../helpers/paymentCalculation');
var _payments = require('../../redux/modules/payments');






var _manageProperties = require('../../redux/modules/manageProperties');var _manageProperties2 = _interopRequireDefault(_manageProperties);




var _UpgradeRegularUserPackage = require('./UpgradeRegularUserPackage.scss');var styles = _interopRequireWildcard(_UpgradeRegularUserPackage);
var _publishAnalytics = require('../../helpers/publishAnalytics');var _publishAnalytics2 = _interopRequireDefault(_publishAnalytics);
var _analyticsManager = require('../../utils/analytics/analyticsManager');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
var UpgradeRegularUserPackageModal = function (_Component) {_inherits(UpgradeRegularUserPackageModal, _Component);function UpgradeRegularUserPackageModal(props) {_classCallCheck(this, UpgradeRegularUserPackageModal);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.






























































    getSelectedPackageData = function (selectedPackage) {
      var packages = (0, _packagesData.getPackages)(false);
      return packages.find(function (pack) {return pack.id === selectedPackage.checked;}) || {};
    };_this.

    getPackageDataForPayment = function (selectedPackage) {var
      period = selectedPackage.period,alternativePeriod = selectedPackage.alternativePeriod;
      var currPackage = _this.getSelectedPackageData(selectedPackage);

      var currentPeriod = (0, _get2.default)(currPackage, 'period.' + period) ? period : alternativePeriod;

      var products = (0, _packagesData.buildPackageDataForPayment)(currPackage, currentPeriod);

      if (!!currPackage.type) {
        _this.increaseProductsAmount(products);
      }

      return { products: products };
    };_this.

    toggleBodyOverflow = function (status) {
      if (!document) {return;}
      document.body.style.overflow = status ? 'hidden' : '';
    };_this.

    increaseProductsAmount = function (products) {
      var propertiesData = (0, _get2.default)(_this.props, 'manageProperties.data.meta.user_properties');

      products.forEach(function (product) {
        if (product.name === _packagesData.possibleProductNames.AUTO_JUMP) {
          var allowedCount = (0, _get2.default)(propertiesData, 'jump_promotion.allowed') || 0;
          product.amount = allowedCount + 1;
        }

        if (product.name === _packagesData.possibleProductNames.HIGHLIGHT) {
          var _allowedCount = (0, _get2.default)(propertiesData, 'promotion.allowed') || 0;
          product.amount = _allowedCount + 1;
        }

        if (product.name === _packagesData.possibleProductNames.TOP) {
          var _allowedCount2 = (0, _get2.default)(propertiesData, 'top_promotion.allowed') || 0;
          product.amount = _allowedCount2 + 1;
        }
      });
    };_this.

    handleSendPayment = function (invoiceDetails) {
      var packages = (0, _packagesData.getPackages)(false);
      var packageData = _this.getPackageDataForPayment(_this.props.selectedPackage);var _calculatePaymentAmou =
      (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(_this.props.selectedPackage, packages),priceGrand = _calculatePaymentAmou.priceGrand;
      var userId = (0, _get2.default)(_this.props, 'userAuthentication.data.id');
      var token = (0, _get2.default)(_this.props, 'userAuthentication.data.access_token');var
      period = _this.props.selectedPackage.period;
      var paymentsNumber = (0, _packagesData.getPaymentsNumber)(period);

      window.hideMessageModal = function () {
        _this.setState({ isIframeOpen: false });
        _this.props.hideMessageModal();
      };
      window.successPayment = _this.props.successPayment;
      window.failPayment = _this.props.failPayment;
      window.isDesktop = !_this.props.isMobile;

      _this.props.sendPaymentRequest({
        data: Object.assign({},
        packageData,
        invoiceDetails, {
          currency: _packagesData.currency.ILS,
          user_id: userId,
          locale: _this.props.locale,
          payments_number: paymentsNumber,
          amount: priceGrand }),

        token: token });

    };_this.














    handlePurchase = function (isSuccessPaid, isRequestFailed, transactionId) {
      var token = (0, _get2.default)(_this.props, 'userAuthentication.data.access_token');

      if (isSuccessPaid) {
        (0, _publishAnalytics2.default)('success/' + isSuccessPaid, 'payment', _this.props);
        _this.purchaseAnalyics(transactionId);
        _this.setState({ isPaymentOpen: false, showProcessOverlay: true });
        return _this.props.verifyPayment({
          data: {
            user_id: _this.props.userAuthentication.data.id,
            locale: _this.props.locale,
            admin: false,
            transactionId: transactionId },

          token: token }).

        then(_this.promoteProperty);
      } else if (isRequestFailed) {
        _this.setState({ isPaymentOpen: false, showProcessOverlay: false });
        return Promise.
        resolve(_this.props.inquirePayment({
          data: {
            user_id: _this.props.userAuthentication.data.id,
            locale: _this.props.locale,
            admin: false,
            transactionId: transactionId },

          token: token })).

        then(_this.props.openMessageModal({
          message:
          _react2.default.createElement(_components.PaymentFailMessage, {
            closeModal: _this.props.hideMessageModal,
            translate: _this.props.packagesTranslate('FailModal') }),


          isCloseButtonInvisible: true,
          className: 'failPaymentModal' }));

      }
      window.hideMessageModal = null;
      window.successPayment = null;
      window.failPayment = null;
      window.isDesktop = null;
      return null;
    };_this.

    promoteProperty = function () {
      var token = (0, _get2.default)(_this.props, 'userAuthentication.data.access_token');var
      paidProducts = _this.props.paidProducts;

      var propertyId = _this.props.currentPropertyId;
      var ids = [propertyId];
      var products = paidProducts && paidProducts.map(function (_ref) {var name = _ref.name;return name;}) || [];

      if (products.includes(_packagesData.possibleProductNames.AUTO_JUMP)) {
        _this.props.activateAutoJump({
          data: { ids: ids, enable: true },
          token: token });

      }

      if (products.includes(_packagesData.possibleProductNames.HIGHLIGHT)) {
        _this.props.updatePropertyHighlighting({
          ids: ids,
          promote: true,
          access_token: token });

      }

      if (products.includes(_packagesData.possibleProductNames.TOP)) {
        _this.props.activateTopPromotion({
          data: { ids: ids, enable: true },
          token: token });

      }

      return null;
    };_this.

    openDetailsToInvoiceForm = function () {
      _this.props.hideUpgradePackageModal();
      _this.props.openMessageModal({
        message:
        _react2.default.createElement(_index.DetailsToInvoiceForm, {
          onSubmit: _this.handleSendPayment,
          selectedPackage: _this.props.selectedPackage,
          currentPackageData: _this.getSelectedPackageData(_this.props.selectedPackage, false),
          packages: (0, _packagesData.getPackages)(false),
          translate: _this.props.packagesTranslate('PurchaseSummery'),
          isMobile: _this.props.isMobile }),


        className: 'invoiceModal',
        shouldCloseOnOverlayClick: false });

      _this.setState({
        isPaymentOpen: true,
        isIframeOpen: true });

    };_this.

    openSuccessMessage = function () {var _this$props$selectedP =
      _this.props.selectedPackage,period = _this$props$selectedP.period,alternativePeriod = _this$props$selectedP.alternativePeriod;
      var currentPackage = _this.state.packages.find(function (item) {return item.id === _this.props.selectedPackage.checked;}) || {};
      var currentPeriod = (0, _get2.default)(currentPackage, 'period.' + period) ? period : alternativePeriod;

      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: styles.successPromoted },
          _react2.default.createElement('div', null, _this.props.translate('managePage', 'promotionSuccessful').replace('%s', currentPeriod)),
          _react2.default.createElement('button', {
              onClick: _this.props.hideMessageModal,
              className: 'btn btn-primary' },

            _this.props.translate('publishProperty', 'ok'))) });




    };_this.state = { isPaymentOpen: false, isIframeOpen: false, showProcessOverlay: false, packages: (0, _packagesData.getPackages)(false) };return _this;}UpgradeRegularUserPackageModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref2) {var redirectUrl = _ref2.redirectUrl,isMessageModalOpen = _ref2.isMessageModalOpen,transactionId = _ref2.transactionId,isRequestFailed = _ref2.isRequestFailed,isSuccessPaid = _ref2.isSuccessPaid,paidProducts = _ref2.paidProducts,paymentError = _ref2.paymentError,promotionUpdated = _ref2.promotionUpdated,promotionFailed = _ref2.promotionFailed,isModalOpen = _ref2.isModalOpen;if (this.props.redirectUrl !== redirectUrl) {this.props.openMessageModal({ message: _react2.default.createElement('iframe', { id: 'payment-iframe', src: redirectUrl, title: 'payments' }, _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })), className: 'invoiceModal', shouldCloseOnOverlayClick: false });this.setState({ isPaymentOpen: true, isIframeOpen: true });}if (this.state.isPaymentOpen && !this.state.isIframeOpen && !isMessageModalOpen && this.props.isMessageModalOpen) {this.handlePurchase(isSuccessPaid, isRequestFailed, transactionId);}if (promotionUpdated && !this.props.promotionUpdated) {this.setState({ showProcessOverlay: false });this.openSuccessMessage();}if (promotionFailed && !this.props.promotionFailed) {this.setState({ showProcessOverlay: false });}if (isModalOpen && !this.props.isModalOpen) {this.toggleBodyOverflow(true);}if (!isModalOpen && this.props.isModalOpen) {this.toggleBodyOverflow(false);}};UpgradeRegularUserPackageModal.prototype.componentWillUnmount = function componentWillUnmount() {this.toggleBodyOverflow(false);};UpgradeRegularUserPackageModal.prototype.purchaseAnalyics = function purchaseAnalyics(transactionId) {var isAgent = false;var selectedPackage = this.props.selectedPackage;var packages = (0, _packagesData.getPackages)(isAgent);var couponType = (0, _get2.default)(this.props, 'discountCoupon.type');var _calculatePaymentAmou2 = (0, _paymentCalculation.calculatePaymentAmountWithVatForRequest)(selectedPackage, packages, couponType),priceGrand = _calculatePaymentAmou2.priceGrand,tax = _calculatePaymentAmou2.tax;var currentPackageData = this.getSelectedPackageData(selectedPackage, isAgent);var period = (0, _get2.default)(selectedPackage, 'period', 1);var propertiesCount = (0, _get2.default)(currentPackageData, 'properties', 1);var type = (0, _get2.default)(currentPackageData, 'type', propertiesCount + ' properties ' + period + 'M');(0, _analyticsManager.trackEcommerce)(transactionId, type, priceGrand, tax, isAgent ? 'agent' : 'user', 1);};UpgradeRegularUserPackageModal.prototype.

  render = function render() {var _this2 = this;
    var currentPackage = this.state.packages.find(function (item) {return item.id === _this2.props.selectedPackage.checked;}) || {};
    var isTopPackage = currentPackage.type === _packagesData.packageTypes.TOP;
    var isRegularPackage = currentPackage.type === _packagesData.packageTypes.REGULAR;

    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement(_components.Modal, {
            className: 'upgradeRegularUserPackageModal',
            isOpen: this.props.isModalOpen,
            onRequestClose: this.props.hideUpgradePackageModal,
            translate: this.props.translate,
            isRtl: this.props.isRtl },

          _react2.default.createElement(_RegularPackages2.default, {
            translate: this.props.packagesTranslate('PackageBlock'),
            locale: this.props.locale,
            isMobile: this.props.isMobile,
            selectedPackage: this.props.selectedPackage,
            currentPropertyData: this.props.currentPropertyData,
            changeSelectedPayment: this.props.changeSelectedPackage }),

          _react2.default.createElement('div', { className: styles.buttonLine },
            _react2.default.createElement('button', {
                className: 'btn btn-primary',
                onClick: this.openDetailsToInvoiceForm,
                disabled: isRegularPackage || isTopPackage && !(0, _get2.default)(this.props, 'currentPropertyData.images.length') },

              this.props.translate('buy')))),



        _react2.default.createElement(_components.PublishProcessOverlay, {
          translate: this.props.translate('publishProperty'),
          isOpen: this.state.showProcessOverlay })));



  };return UpgradeRegularUserPackageModal;}(_react.Component);


UpgradeRegularUserPackageModal.propTypes = {
  translate: _propTypes2.default.func,
  packagesTranslate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  paidProducts: _propTypes2.default.array,
  userAuthentication: _propTypes2.default.object,
  manageProperties: _propTypes2.default.object,
  currentPropertyId: _propTypes2.default.string,
  hideUpgradePackageModal: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  selectedPackage: _propTypes2.default.object,
  changeSelectedPackage: _propTypes2.default.func,
  clearPaymentData: _propTypes2.default.func,
  sendPaymentRequest: _propTypes2.default.func,
  successPayment: _propTypes2.default.func,
  verifyPayment: _propTypes2.default.func,
  inquirePayment: _propTypes2.default.func,
  failPayment: _propTypes2.default.func,
  activateAutoJump: _propTypes2.default.func,
  activateTopPromotion: _propTypes2.default.func,
  updatePropertyHighlighting: _propTypes2.default.func,
  isModalOpen: _propTypes2.default.bool,
  isRequestFailed: _propTypes2.default.bool,
  isSuccessPaid: _propTypes2.default.bool,
  paymentError: _propTypes2.default.object,
  iframeLoading: _propTypes2.default.bool,
  redirectUrl: _propTypes2.default.string,
  transactionId: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  promotionUpdated: _propTypes2.default.bool,
  promotionFailed: _propTypes2.default.bool,
  isMessageModalOpen: _propTypes2.default.bool,
  currentPropertyData: _propTypes2.default.object };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    packagesTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    userAuthentication: state.userAuthentication,
    paidProducts: state.payments.paidProducts,
    redirectUrl: state.payments.redirectUrl,
    paymentError: state.payments.error,
    transactionId: state.payments.transactionId,
    iframeLoading: state.payments.iframeLoading,
    isSuccessPaid: state.payments.isSuccessPaid,
    isRequestFailed: state.payments.isRequestFailed,
    manageProperties: state.manageProperties,
    isMessageModalOpen: state.messageModal.isMessageModalOpen,
    isModalOpen: state.upgradeRegularUserPackage.upgradeRegularPackageIsOpen,
    selectedPackage: state.upgradeRegularUserPackage.selectedPackage,
    promotionUpdated: state.manageProperties.promotionUpdated,
    promotionFailed: state.manageProperties.promotionFailed,
    currentPropertyId: state.upgradeRegularUserPackage.currentPropertyId,
    currentPropertyData: ((0, _get2.default)(state, 'manageProperties.data.data') || []).
    find(function (item) {return item.id === state.upgradeRegularUserPackage.currentPropertyId;}) || {} };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, {
  hideUpgradePackageModal: _upgradeRegularUserPackage.hideUpgradePackageModal,
  changeSelectedPackage: _upgradeRegularUserPackage.changeSelectedPackage,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  sendPaymentRequest: _payments.sendPaymentRequest,
  successPayment: _payments.successPayment,
  failPayment: _payments.failPayment,
  clearPaymentData: _payments.clearPaymentData,
  verifyPayment: _payments.verifyPayment,
  inquirePayment: _payments.inquirePayment,
  activateAutoJump: _manageProperties.activateAutoJump,
  activateTopPromotion: _manageProperties.activateTopPromotion,
  updatePropertyHighlighting: _manageProperties.updatePropertyHighlighting })(
UpgradeRegularUserPackageModal);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpgradeRegularUserPackage/UpgradeRegularUserPackage.js
// module id = 2994
// module chunks = 0